"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findIndex = void 0;
exports.findIndex = (iterable, iteratee) => {
    for (let i = 0; i < iterable.length; i++) {
        if (iteratee(iterable[i], i, iterable)) {
            return i;
        }
    }
    return -1;
};
//# sourceMappingURL=find-index.js.map